import { WidgetViews, type WidgetApps } from '@/types'
import { markRaw, type Component, defineAsyncComponent, type AsyncComponentLoader } from 'vue'

import Processing from '@/views/Processing.vue'
import Loading from '@/views/Loading.vue'
import Error from '@/views/Error.vue'
import CloseWidget from '@/views/CloseWidget.vue'
import Start from '@/views/apps/_customPage/Start.vue'

const getAsyncComponentConfig = (loader: AsyncComponentLoader) => defineAsyncComponent({
    loader,
    loadingComponent: Loading,
    delay: 300,
})

export const widgetViews: Record<WidgetViews | WidgetApps, Component> = {
    [WidgetViews.PROCESSING]: markRaw(Processing),
    [WidgetViews.LOADING]: markRaw(Loading),
    [WidgetViews.ERROR]: markRaw(Error),
    [WidgetViews.CLOSE_WIDGET]: markRaw(CloseWidget),
    [WidgetViews.CUSTOM_PAGE_PREVIEW]: markRaw(Start),
    'custom-page': markRaw(Start),
    'workflow-finish': getAsyncComponentConfig(() => import('@/views/WorkflowFinish.vue')),
    'zoho-sign': getAsyncComponentConfig(() => import('@/views/apps/zoho-sign/Index.vue')),
    'edo-app': getAsyncComponentConfig(() => import('@/views/apps/edo-app/Index.vue')),
    'p24-verification-payment': getAsyncComponentConfig(() => import('@/views/apps/p24-verification-payment/Index.vue')),
    'transactionlink-open-banking': getAsyncComponentConfig(() => import('@/views/apps/transactionlink-open-banking/Index.vue')),
    'transactionlink-sms-verification': getAsyncComponentConfig(() => import('@/views/apps/transactionlink-sms-verification/Index.vue')),
    'veriff-video-verification': getAsyncComponentConfig(() => import('@/views/apps/veriff-video-verification/Index.vue')),
    'veriff-age-estimation': getAsyncComponentConfig(() => import('@/views/apps/veriff-age-estimation/Index.vue')),
    'comply-cube-video-verification': getAsyncComponentConfig(() => import('@/views/apps/comply-cube-video-verification/Index.vue')),
    twilio: getAsyncComponentConfig(() => import('@/views/apps/twilio/Index.vue')),
    'ondato-vv': getAsyncComponentConfig(() => import('@/views/apps/ondato-video-verification/Index.vue')),
    'idenfy-video-verification': getAsyncComponentConfig(() => import('@/views/apps/idenfy-video-verification/Index.vue')),
    yapily: getAsyncComponentConfig(() => import('@/views/apps/yapily/Index.vue')),
    'moje-id-verification': getAsyncComponentConfig(() => import('@/views/apps/moje-id-verification/Index.vue')),
    'gbg-id-verification': getAsyncComponentConfig(() => import('@/views/apps/gbg-id-verification/Index.vue')),
    'autopay-verification-payment': getAsyncComponentConfig(() => import('@/views/apps/autopay-verification-payment/Index.vue')),
    'mobywatel-id-verification': getAsyncComponentConfig(() => import('@/views/apps/mobywatel-id-verification/Index.vue')),
    'smart-id-verification': getAsyncComponentConfig(() => import('@/views/apps/smart-id-id-verification/Index.vue')),
    'bank-id-norway-verification': getAsyncComponentConfig(() => import('@/views/apps/bank-id-norway-verification/Index.vue')),
    'bank-id-denmark-verification': getAsyncComponentConfig(() => import('@/views/apps/bank-id-denmark-verification/Index.vue')),
    'comply-cube-face-authentication': getAsyncComponentConfig(() => import('@/views/apps/comply-cube-face-authentication/Index.vue')),
    'bank-id-czechia-verification': getAsyncComponentConfig(() => import('@/views/apps/bank-id-czechia-verification/Index.vue')),
    'bank-id-finland-verification': getAsyncComponentConfig(() => import('@/views/apps/bank-id-finland-verification/BankIdFinlandVerification.vue')),
    'au10tix-video-verification': getAsyncComponentConfig(() => import('@/views/apps/au10tix-video-verification/Au10tixVideoVerification.vue')),
}

export const viewsKeys = Object.keys(widgetViews)
